import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles,
  Tabs,
  Tab,
  Paper,
  Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import LogsTable from './LogsTable';
import data from './data';
import LogTable from './LogTable';
import { useSelector, useDispatch } from 'react-redux';
import {
  getAdminIssuerLogsAction,
  getAdminLogsAction,
  getHistoryLogs,
  getIssuers,
  getSelf
} from 'src/store/actions/LogActions';
import LogsFilter from './LogsFilter';
import moment from 'moment';
import { getClientsAction } from 'src/store/actions/ClientManagerActions';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const Logs = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const profile = JSON.parse(sessionStorage.getItem('profile'));
  const [loading, setLoading] = useState(false);
  const logsData = useSelector((state) => state.Logs.logs);
  const adminLogData = useSelector((state) => state.Logs.adminLog);
  const issuerAdminLogData = useSelector((state) => state.Logs.issuerAdminLog);
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    async function fetchSelf() {
      setLoading(true);
      const response = await dispatch(getSelf('_', profile));
      await dispatch(getAdminLogsAction('_', profile));
      const res =
        profile?.super == 1 &&
        (await dispatch(getAdminIssuerLogsAction('_', profile)));
      if (response) {
        setLoading(false);
      }
    }
    fetchSelf();
    dispatch(getClientsAction());
    return () => {
      setLoading(false);
    };
  }, []);

  const tableConfig = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Activity Log Description',
      value: 'activityLogDesc',
      align: 'center'
    },

    {
      title: ' Date',
      value: 'dateCreated',
      align: 'center',
      render: (row) =>
        moment(row.dateCreated * 1000).format('DD/MM/YYYY hh:mm a')
    }
  ];

  const tableConfigPriv = [
    {
      title: 'S/N',
      value: 'sn',
      align: 'center',
      render: (row, i) => <> {i + 1} </>
    },
    {
      title: 'Activity Log Description',
      value: 'activityLogDesc',
      align: 'center'
    },

    {
      title: ' Date',
      value: 'dateCreated',
      align: 'center',
      render: (row) =>
        moment(row.dateCreated * 1000).format('DD/MM/YYYY hh:mm a')
    },
    {
      title: ' Fullname',
      value: 'fullname',
      align: 'center',
      render: (row) => row?.admin?.fullname || row?.issuer?.fullname
    }
  ];

  return (
    <Page className={classes.root} title="Logs">
      <Container maxWidth={false}>
        <Box mt={2}>
          <Paper mt={3}>
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              centered
            >
              <Tab label="SELF" />
              <Tab label="Staff" />
              {profile?.super == 1 && <Tab label="Issuers" />}
            </Tabs>
            <TabPanel value={value} index={0}>
              <>
                <LogsFilter type="self" />
                <Box mt={4}>
                  <LogTable
                    tableConfig={tableConfig}
                    data={logsData}
                    loading={loading}
                  />
                </Box>
              </>
            </TabPanel>

            <TabPanel value={value} index={1}>
              <>
                <LogsFilter type="admin" />
                <Box mt={4}>
                  <LogTable
                    tableConfig={tableConfigPriv}
                    data={adminLogData}
                    loading={loading}
                  />
                </Box>
              </>
            </TabPanel>

            {profile?.super == 1 && (
              <TabPanel value={value} index={2}>
                <>
                  <LogsFilter type="issuer" />
                </>
                <Box mt={4}>
                  <LogTable
                    tableConfig={tableConfigPriv}
                    data={issuerAdminLogData}
                    loading={loading}
                  />
                </Box>
              </TabPanel>
            )}
          </Paper>
        </Box>
      </Container>
    </Page>
  );
};

export default Logs;
